export function redirectParent(url) {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const message = JSON.stringify({
        message: 'redirect',
        url: url,
        id: id
    });
    window.parent.postMessage(message, '*');
}